/**
 * Who may message whom on an event (COMMUNICATIONS-DESIGN D11, §7.2).
 *
 * Two grants per party, not one, because "may use messaging on this event" and
 * "may talk to the other side without the office in the room" are different
 * things, and collapsing them hands the second away with the first:
 *
 * | party | may join the event's conversations | may be in one with the counterparty |
 * |---|---|---|
 * | client (`EventUser`) | `canMessage` | `canMessageVendors` |
 * | vendor (event–vendor link `metadata`) | `canMessage` | `canMessageClients` |
 *
 * The vendor half lives in the link's `metadata` JSON — per event, which is the
 * right granularity: a caterer trusted to write to one client is not thereby
 * trusted on every event. Everything defaults off. ADMIN and PLANNER need none
 * of it.
 *
 * ⚠️ **The counterparty grant is nothing on its own.** It counts only beside
 * the party's `canMessage`, and client↔vendor contact needs both sides' pairs —
 * `clientMayReachVendor`, the one statement of that rule.
 */
/**
 * A vendor's grants from its event link's `metadata`.
 *
 * Only a literal `true` grants. The column is free-form JSON written by more
 * than one screen, and a string "false" or a missing key must never read as
 * permission.
 */
export function vendorMessagingOf(metadata) {
    const meta = metadata && typeof metadata === 'object' ? metadata : {};
    return {
        canMessage: meta.canMessage === true,
        canMessageClients: meta.canMessageClients === true,
    };
}
/** Whether a client and a vendor may be in a conversation about their event together. */
export function clientMayReachVendor(client, vendor) {
    return (client.canMessage && client.canMessageVendors && vendor.canMessage && vendor.canMessageClients);
}
//# sourceMappingURL=messagingPermissions.js.map